"use client";

import { useEffect } from "react";

// Exposes the build/deploy version in DevTools: type `sharifnama.version`.
export function BuildInfo() {
  useEffect(() => {
    const info = Object.freeze({
      version: process.env.NEXT_PUBLIC_APP_VERSION ?? "dev",
      commit: process.env.NEXT_PUBLIC_APP_COMMIT ?? "",
      builtAt: process.env.NEXT_PUBLIC_APP_BUILT_AT ?? "",
    });
    (window as unknown as Record<string, unknown>).sharifnama = info;
    console.info(`[sharifnama] ${info.version} (${info.commit || "no-commit"}) built ${info.builtAt}`);
  }, []);
  return null;
}
